import React from 'react';
import './StobWorkWithUs.scss';
import './StobWorkWithUsResponsive.scss';
import heroFive from 'assets/images/common-image/services/work-with-us.png';
import workWithUsBg from 'assets/images/common-image/services/workwithus-bg.png';
import { useDispatch, useSelector } from 'react-redux';

const StobWorkWithUs = () => {
	const serviceContent = useSelector((state) => state.content?.service);
	const serviceData = serviceContent?.content ? JSON.parse(serviceContent?.content) : '';

	return (
		<>
			<section className="StobWorkWithUs d-flex align-items-center relative" style={{ background: `url(${workWithUsBg})` }}>
				<div className="sectionTag secTagRight">
					<span className="">ACCESSIBILITY</span>
				</div>
				<div className="workWithLeft">
					<div className="workWithImg">
						<img alt="" src={serviceData?.section3?.img ? `${process.env.REACT_APP_RESOURCE_URL}/${serviceData?.section3?.img}` : heroFive} />
					</div>
				</div>
				<div className="workWithRight">
					<div className="workWithRightInner">
						<h3
							dangerouslySetInnerHTML={{
								__html: serviceData?.section3?.heading ?? `10 Reason to work with us`,
							}}
						></h3>
						<div
							className="w-100"
							dangerouslySetInnerHTML={{
								__html:
									serviceData?.section3?.description ??
									`
								<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
								<ul>
									<li>Lorem ipsum dolor sit amet, c elit ipsum </li>
									<li>Lorem ipsum dolor sit amet, consectetur adipiscing elit ipsum </li>
									<li>Lorem ipsum dolor sit amet, consectetur adipiscing </li>
									<li>sit amet, consectetur adipiscing elit ipsum </li>
									<li>Lorem ipsum dolor sit amet, c elit ipsum </li>
									<li>Lorem ipsum dolor sit amet, consectetur adipiscing elit ipsum </li>
									<li>Lorem ipsum dolor sit amet, consectetur adipiscing </li>
									<li>sit amet, consectetur adipiscing elit ipsum </li>
									<li>Lorem ipsum dolor sit amet, consectetur adipiscing </li>
									<li>sit amet, consectetur adipiscing elit ipsum </li>
								</ul>
								`,
							}}
						></div>
					</div>
				</div>
			</section>
		</>
	);
};

export default StobWorkWithUs;
